export default __webpack_public_path__ + "static/media/TX_Elemental_Thunder_Grimory.e8c1525b.png";